import {type FunctionalComponent, h,type VNode} from '@stencil/core';
import { GuidedHistoryOfSearchesItem} from '../../models/quick-link';
import type {GuidedV2Emitters} from '../../models/eventNames';

export type HistoryOfSearchesProps ={
  results: GuidedHistoryOfSearchesItem[];
  highlightedIndex: number;
  historyLabel: string;
  eventEmitters: GuidedV2Emitters;
};

export const GuidedV2HistoryOfSearches: FunctionalComponent<HistoryOfSearchesProps> = (props)=>{
    if(props.results.length === 0){
      return <div data-error="history of searches has no items"></div> as VNode;
    }
    const emitters = props.eventEmitters() ?? undefined;
    if(emitters == undefined){
      console.error("No event emitters found"); //eslint-disable-line
    }

    return <div class="guided-v2-history-of-searches">
      <div class="guided-v2-history-of-searches__label">{props.historyLabel}</div>
      <ul class="guided-v2-history-of-searches__items">
        {props.results.map((item, index) => (
          <li
            class={{
              'guided-v2-history-of-searches__item': true,
              'guided-v2-history-of-searches__item--highlighted': index === props.highlightedIndex,
            }}
            onClick={() => {
                emitters.historyClicked.emit({term: item.term});}}
          >
            <div class='guided-v2-history-of-searches__quartz-icon-wrapper'>
              <se-icon size="small">history</se-icon>
            </div>
            <div class="guided-v2-history-of-searches__item__text">
              {item.title}
            </div>
            {item.deletionCallback &&
              <div class="guided-v2-history-of-searches__item__delete">
                <qds-button
                  importance="subdued"
                  icon-name="cross-small"
                  icon-only="true"
                  onClick={(e) => {
                      e.stopPropagation();
                      item.deletionCallback();}}
                ></qds-button>
              </div>
            }
          </li>
        ))}
      </ul>
    </div> as VNode;
};
